
import InlineCalendar from 'vux/src/components/inline-calendar/index.vue'

import addressComponent from '../../common/address';
import checkBox from '../../common/checkBox.vue';
import compressImage from '../../../components/common/compressImage';
export default {
components: {
InlineCalendar,
addressComponent,
checkBox
},
mixins: [compressImage],
data() {
return {
calendarShow: true,
calendarvValue: null,
nameEdit: false,
phoneEdit: false,
sexEdit: false,
birthdayEdit: false,
addressEdit: false,
defaultValue: 'gd',
sexList: [
{
label: '男',
value: 1
},
{
label: '女',
value: 2
}
],
userInfo: {
sex: '请选择',
birthday: '请选择',
name: '请填写',
phone: '请填写',
addressStr: '请选择',
addressList: [],
poster: './static/images/default_handsome.jpg'
},
editUserInfo: {
sex: '',
birthday: '',
name: '',
phone: '',
addressStr: '',
addressList: [],
poster: './static/images/default_handsome.jpg'
},
inputReset: true
};
},
methods: {

setUserInfo(key) {
let that = this;
var url = '',
data = {};
if (key == 'gender') {
url = '/api/v1.0/lonbonShop/changeGender';
data = {
shopperId: that.userInfo.shopperId,
gender: that.editUserInfo.gender
};
}
if (key == 'phone') {
url = '/api/v1.0/lonbonShop/changePhoneNum';
data = {
shopperId: that.userInfo.shopperId,
phoneNum: that.editUserInfo.phone
};
}
if (key == 'name') {
url = '/api/v1.0/lonbonShop/changeDisplayName';
data = {
shopperId: that.userInfo.shopperId,
displayName: that.editUserInfo.name
};
that.$store.state.userInfo.displayName = that.editUserInfo.name;
}
that.ajaxSetUserInfo(url, data, () => {
if (key == 'phone') {
that.phoneEdit = false;
that.userInfo[key] = that.editUserInfo.phone;
}
if (key == 'name') {
that.nameEdit = false;
that.userInfo[key] = that.editUserInfo.name;
}
if (key == 'gender') {
that.sexEdit = false;
that.userInfo[key] = that.editUserInfo.gender;
that.userInfo.sex = that.editUserInfo.gender == 1 ? '男' : '女';
}
});
},
onBirthdayChange(val) {

this.editUserInfo.birthday = val;
},

setUserBirthday() {
let that = this;
if (!that.editUserInfo.birthday) {
that.$vux.toast.text('请选择出生日期');
return;
}
var ss = (that.editUserInfo.birthday + ' 00:00:00').replace(/-/g, '/');
var data = {
shopperId: that.userInfo.shopperId,
birthday: new Date(ss).getTime() / 1000
};
that.ajaxSetUserInfo('/api/v1.0/lonbonShop/changeBirthday', data, () => {
that.userInfo.birthday = that.editUserInfo.birthday;
that.birthdayEdit = false;
});
},

showSetAddress() {
this.$refs.addressPopupRef.showPopup(this.userInfo.addressList);
},
loadData(regionId) {
let that = this;
that.$axios
.get('/api/v1.0/region', {
params: {
regionId: regionId || -1,
type: 1
}
})
.then(function(res) {
if (res.status == 200) {
that.regionList = res.body.regionList;
that.setCheck();
}
});
},
selectAddressHandle() {
var list = this.$refs.addressComponentRef.getCheckList();
this.userInfo.addressList = list;
var regionCombinationArr = [],
regionDescArr = [];
list.forEach(item => {
regionCombinationArr.push(item.regionId);
regionDescArr.push(item.regionName);
});
let that = this;
var data = {
shopperId: that.userInfo.shopperId,
regionCombination: regionCombinationArr.join('|'),
regionDesc: regionDescArr.join('/')
};
that.ajaxSetUserInfo('/api/v1.0/lonbonShop/changeRegion', data, () => {
that.userInfo.addressStr = regionDescArr.join('/');
that.closeEditAddress();
});
},

upload() {
console.log('头像选择');
this.$refs.uploadImagesRef.dispatchEvent(new MouseEvent('click'));
},
changeImage(e) {
let that = this;
that.$vux.loading.show();
var files = e.target.files;
var file = files[0];
that.myCompressImage(file, function(result) {
that.userInfo.poster = that.$store.state.userInfo.poster = result;
var formData = new FormData();
formData.append('shopperId', that.userInfo.shopperId);
formData.append('file', that.convertBase64UrlToBlob(that.uploadImage), file.name);
that.$axios.post('/api/v1.0/lonbonShop/changeHeadImage', formData).then(function(response) {
if (response.status == 200) {
that.$vux.toast.text('已修改');
that.$vux.loading.hide();
}
});
});
this.inputReset = false;
this.$nextTick(() => {
this.inputReset = true;
});
},

getUserInfo() {
let that = this;
let accountType;
if (that.$isWeixin() || that.$isPc()) {
accountType = 10;
} else {
accountType = 1;
}
that.$axios
.get('/api/v1.0/lonbonShop/userInfo', {
params: {
accountType: accountType
}
})
.then(function(response) {
if (response.status == 200) {
var user = response.body;
var genderStr = '请选择';
if (user.gender) {
if (user.gender == 1) {
genderStr = '男';
} else {
genderStr = '女';
}
}
var addressList = [];
if (user.regionCombination && user.regionDesc) {
var regionCombinationArr = user.regionCombination.split('|'),
regionDescArr = user.regionDesc.split('/');
regionCombinationArr.forEach((item, index) => {
addressList.push({
regionId: regionCombinationArr[index],
regionName: regionDescArr[index]
});
});
}
var userInfo = {
poster: that.$store.state.APPPAGE.dealHeadImage(user.headImage),
name: user.displayName ? user.displayName : '请填写',
accountId: user.accountId,
shopperId: user.shopperId,
sex: genderStr,
gender: user.gender,
birthday: user.birthday ? that.$moment(user.birthday * 1000).format('YYYY-MM-DD') : '请选择',
phone: user.phoneNum ? user.phoneNum : '请填写',
addressStr: user.regionDesc ? user.regionDesc : '请选择',
addressList: addressList
};
that.userInfo = userInfo;
that.editUserInfo = JSON.parse(JSON.stringify(userInfo));
if (that.userInfo.birthday && that.userInfo.birthday != '请选择') {
that.calendarvValue = that.userInfo.birthday;
}
console.log(that.calendarvValue);
}
});
},
ajaxSetUserInfo(url, data, callback) {
let that = this;
that.$axios.post(url, that.qs.stringify(data)).then(function(response) {
if (response.status == 200) {
that.$vux.toast.text('已修改');
callback && callback();
}
});
},
resetInput(item) {
this.editUserInfo[item] = this.userInfo[item];
if (item == 'birthday') {
if (this.userInfo[item] && this.userInfo[item] != '请选择') {
this.calendarvValue = this.userInfo[item];
} else {
this.calendarvValue = null;
}
console.log(this.calendarvValue);
}
},
showEditAddress() {
this.addressEdit = true;
this.$refs.addressComponentRef.showPopup(this.editUserInfo.addressList);
},
closeEditAddress() {
this.addressEdit = false;
this.$refs.addressComponentRef.closePopup();
this.resetInput('addressList');
}
},
mounted() {
this.getUserInfo();
}
};



// WEBPACK FOOTER //
// ./src/pcComponents/mine/personalSettings/personalInfo.vue